const uuidRegex =
  /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
const validateUUID = (uuid: string): boolean => {
  return typeof uuid === 'string' && uuidRegex.test(uuid);
};

// Returns true for valid UUIDs, whether standard or condensed
export const isUUID = (uuid: string): boolean => {
  return isCondensedUUID(uuid) || isStandardUUID(uuid);
};

export const isStandardUUID = (uuid: string): boolean => {
  return validateUUID(uuid);
};

// Returns true only for valid condensed UUIDs
export const isCondensedUUID = (uuid: string): boolean => {
  try {
    const a = uuid.substring(0, 8);
    const b = uuid.substring(8, 12);
    const c = uuid.substring(12, 16);
    const d = uuid.substring(16, 20);
    const e = uuid.substring(20, 32);
    const newUUID = `${a}-${b}-${c}-${d}-${e}`;
    return validateUUID(newUUID);
  } catch (e) {
    return false;
  }
};

// Converts a UUID to a condensed UUID
// If passed a condensed UUID, returns it
// If passed an invalid UUID, throws
export const toCondensedUUID = (uuid: string): string => {
  if (isCondensedUUID(uuid)) {
    return uuid;
  }
  if (!isStandardUUID(uuid)) {
    throw new Error(`${uuid} is not a valid UUID`);
  }
  return uuid.split('-').join('');
};

// Converts a condensed UUID to a standard UUID
// If passed a standard UUID, returns it
// If passed an invalid UUID (condensed or not), throws
export const toStandardUUID = (uuid: string): string => {
  if (isStandardUUID(uuid)) {
    return uuid;
  }
  try {
    const a = uuid.substring(0, 8);
    const b = uuid.substring(8, 12);
    const c = uuid.substring(12, 16);
    const d = uuid.substring(16, 20);
    const e = uuid.substring(20, 32);
    const newUUID = `${a}-${b}-${c}-${d}-${e}`;
    if (!validateUUID(newUUID)) {
      throw new Error();
    }
    return newUUID;
  } catch (e) {
    throw new Error(`${uuid} is not a valid condensed UUID`);
  }
};
